<template>
  <title>0LP | Photography</title>
    <link rel="stylesheet" href="\css\photography.css">
    <body>

      <div class="photography-title-container">
        <a href="/" ><img class="logo" src="/images/logo/logo_crp.png" ></a>

        <h3>Photography Gallery</h3>
      </div>
      <div class="full-img" v-if="isFullImgBoxVisible">
        <img :src="fullImgSrc" id="fullImg">
        <span @click.stop="closeFullImg">X</span>
      </div>

      <div class="img-gallery">
        <img v-for="(photo, index) in photographs" v-bind:key="index" :src="photo.path" :alt="photo.name" @click="openFullImg(photo.path)" />
      </div>
    </body>
</template>
<script>
// import axios from 'axios';
export default{
    
    name: 'PhotoGraphy',
    data() {
        return {
            isFullImgBoxVisible: false,
            fullImgSrc: '',
            photographs: [],
        }
    },
    created() {
        this.fetchPhotographs();
    },
    methods:{
        async fetchPhotographs() {
            try {
            const response = [
              {
                id: 6,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/rsG6yHt9/IMG-4091.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 7,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/m2RfpT0p/IMG-4096.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 8,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/6ppswY6d/IMG-4883.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 9,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/KYCCPbPN/IMG-4885.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 10,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/pT84kSkt/IMG-5469.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 11,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/MKzNbdQh/IMG-5743.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 12,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/m2VqdC3h/IMG-5745.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 13,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/Bn6zRbNp/IMG-5746.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 14,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/BQZ71tW3/IMG-5747.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 15,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/g2nMN5kB/IMG-5751.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 16,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/1tZJR30L/IMG-6481.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 17,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/90LpBt3h/IMG-6546.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 18,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/vm5tKdRX/IMG-6547.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 19,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/503qxq2C/IMG-6548.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 20,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/Wz1mtFdf/IMG-6550.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 72,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/6QnN3RsG/7.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 89,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/59HDNLw9/8.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 90,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/BbcTQmpw/66.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 91,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/nrRLk7hh/123.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 92,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/7L9r046x/A5.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 93,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/wvNPFdxy/DCSFE3F.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 94,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/pTBQP0qc/DSC05818.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 95,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/0yfJM6pr/DSC06164.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 96,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/4yPtgJwb/IMG-0835.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 97,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/dQjGdBvk/IMG-0919.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 98,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/7YB7tZ5q/IMG5.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 99,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/ncL9mf0g/DSC06308.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 100,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/MpMcsbkY/DSC06662.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 101,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/43pYGfx7/DSC06674.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 102,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/W3jhbBd9/LRM-EXPORT-20200514-171230.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 103,
                title: '',
                category: 'photography',
                path: 'https://i.postimg.cc/Bbnb22cH/LRM-EXPORT-20200619-201346.jpg',
                type: 'image',
                video_code: null
              },
            ];
            this.photographs = response;
            } catch (error) {
            console.error('Error fetching team members:', error);
            }
        },
        openFullImg(image) {
      // console.log('Opening full image', image);
      this.isFullImgBoxVisible = true;
      this.fullImgSrc = image;
    },
    closeFullImg() {
      // console.log('Closing full image');
      this.isFullImgBoxVisible = false;
    },
    }
}

</script>